var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoctorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(-39 -304)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(39 304)",
    fill: "#c8d3ec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190",
    transform: "translate(468.735 -301.976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189",
    transform: "translate(-420.735 608.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M-361.639,613.653c0,3.5-2.066,4.405-4.615,4.405s-4.616-.9-4.616-4.405,2.067-5.181,4.616-5.181S-361.639,610.149-361.639,613.653Z",
    transform: "translate(374.59 -608.472)",
    fill: "#736357"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(0 1.185)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 4.954,
    height: 4.092,
    transform: "translate(5.859 9.177)",
    fill: "#efb078"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M-404.062,793.874v-10.34a3.889,3.889,0,0,0-3.877-3.877h-8.918a3.889,3.889,0,0,0-3.877,3.877v10.34Z",
    transform: "translate(420.735 -768.068)",
    fill: "#a3978e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M-324.19,782.228l-1.33-1.834-1.33,1.834,1.1,1.516-1.1,8.44,1.33,2.049,1.33-2.049-1.1-8.44Z",
    transform: "translate(333.857 -768.749)",
    fill: "#f0614b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(8.337 11.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M-300.687,793.874v-10.34a3.889,3.889,0,0,0-3.877-3.877h-1.107l-3.352,10.038v4.179Z",
    transform: "translate(309.024 -779.657)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M-304.738,784.784l-.733-1.25,1.594-.56-.5-3.313c-.064,0-.128,0-.193,0h-1.107l-3.352,10.038v4.179h.467Z",
    transform: "translate(309.024 -779.657)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(0 11.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M-420.735,793.874v-10.34a3.889,3.889,0,0,1,3.877-3.877h1.108L-412.4,789.7v4.179Z",
    transform: "translate(420.735 -779.657)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M-377.134,784.784l.733-1.25-1.594-.56.5-3.313c.064,0,.128,0,.193,0h1.107l3.352,10.038v4.179h-.466Z",
    transform: "translate(381.185 -779.657)",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M-355.184,629.956c0,3.093-1.813,5.6-4.049,5.6s-4.05-2.507-4.05-5.6,1.813-5.6,4.05-5.6S-355.184,626.862-355.184,629.956Z",
    transform: "translate(367.57 -624.355)",
    fill: "#ffc88d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(5.041 10.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M-352.385,768.394l-.8.841,2.046,2.348,1.249-2.326Z",
    transform: "translate(353.182 -768.394)",
    fill: "#d1c5bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M-306.525,768.394l.8.841-2.046,2.348-1.25-2.326Z",
    transform: "translate(312.319 -768.394)",
    fill: "#d1c5bd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M-346.04,616.348c1.648,3.426,6.689,1.551,6.689,1.551l-1-1.906-2.2-1.454-2.972.872S-346.234,615.8-346.04,616.348Z",
    transform: "translate(351.645 -614.086)",
    fill: "#736357"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(10.683 16.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M-275.342,835.591a1.121,1.121,0,0,1-1.121,1.12,1.121,1.121,0,0,1-1.121-1.12,1.121,1.121,0,0,1,1.121-1.121A1.121,1.121,0,0,1-275.342,835.591Z",
    transform: "translate(277.584 -834.47)",
    fill: "#d33c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M-271.3,839.747h-.515v-.516h-.5v.516h-.515v.5h.515v.515h.5v-.515h.515Z",
    transform: "translate(273.183 -838.876)",
    fill: "#f7f4f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(10.716 19.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M-272.74,874a.388.388,0,0,1-.387.388h-3.619a.389.389,0,0,1-.388-.388v-1.874a.389.389,0,0,1,.388-.388h3.619a.389.389,0,0,1,.387.388Z",
    transform: "translate(277.134 -871.281)",
    fill: "#a3978e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M-273.539,877.336a.131.131,0,0,1-.129-.129v-1.874a.13.13,0,0,1,.129-.129h3.62a.131.131,0,0,1,.129.129v1.874a.131.131,0,0,1-.129.129Z",
    transform: "translate(273.927 -874.492)",
    fill: "#f7f4f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 0.42,
    height: 1.034,
    transform: "translate(1.987)",
    fill: "#635952"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 3.296,
    height: 0.237,
    transform: "translate(0.549 1.401)",
    fill: "#a3978e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 3.296,
    height: 0.237,
    transform: "translate(0.549 2.046)",
    fill: "#a3978e"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorIcon);
export default __webpack_public_path__ + "static/media/doctor-icon.04e7bf81b2fe9f63d47e2a2611a7c3e2.svg";
export { ForwardRef as ReactComponent };